document.addEventListener('DOMContentLoaded', () => {

  const section = document.querySelector('.wg-category-grid');

  if (!section) return;

  /*==================================
  REVEAL ON SCROLL
  ==================================*/

  const cards = section.querySelectorAll('.wg-category-card');

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        entry.target.classList.add('is-visible');

        observer.unobserve(entry.target);

      }

    });

  }, {

    threshold:0.15

  });

  cards.forEach(card => observer.observe(card));



  /*==================================
  MOBILE DRAG SCROLL
  ==================================*/

  const wrapper = section.querySelector('.wg-category-grid__wrapper');

  if (!wrapper) return;

  if (window.innerWidth <= 767) {

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    wrapper.addEventListener('mousedown', (e) => {

      isDown = true;
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;

    });

    wrapper.addEventListener('mouseleave', () => {

      isDown = false;

    });

    wrapper.addEventListener('mouseup', () => {

      isDown = false;

    });

    wrapper.addEventListener('mousemove', (e) => {

      if (!isDown) return;

      e.preventDefault();

      const x = e.pageX - wrapper.offsetLeft;

      const walk = (x - startX) * 1.5;

      wrapper.scrollLeft = scrollLeft - walk;

    });

  }

});